import React from 'react';

import s from './Loader.module.scss';

const Loader = () => (
  <div className={s.Loader}>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Loader;
